import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import type { Node } from "@contentful/rich-text-types"
import { ContentfulMarkdown } from "#/services/contentful/contentful-markdown-renderer"
import { RichTextContext } from "#/services/contentful/shared/rich-text"
import type { ContentBlockNode, ContentNode } from "../renderer/types"
import { ContentItem } from "./content-item"

function renderEmbeddedEntry(node: Node) {
  const target = node.data?.target as ContentNode | undefined
  if (!target) return null

  return (
    <Box component="span">
      <RichTextContext.Provider value={{ isInRichText: true }}>
        <ContentItem content={target} />
      </RichTextContext.Provider>
    </Box>
  )
}

export function ContentBlockContent({ content }: { content: ContentBlockNode }) {
  return (
    <>
      {content.body && <ContentfulMarkdown>{content.body}</ContentfulMarkdown>}
      {content.richTextBody && (
        <Box>
          {documentToReactComponents(content.richTextBody, {
            renderNode: {
              [INLINES.EMBEDDED_ENTRY]: renderEmbeddedEntry,
              [BLOCKS.EMBEDDED_ENTRY]: renderEmbeddedEntry
            }
          })}
        </Box>
      )}
    </>
  )
}
